import React from 'react';

import { useTheme } from '@chakra-ui/react';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const PraiseAdvice = ({ value }) => {
  const theme = useTheme();
  if (value === 'APPRECIATIVE') {
    return (
      <TextBodyMedium bold color={theme.colors.functional['1A5724']}>
        Praise
      </TextBodyMedium>
    );
  }
  if (value === 'CONSTRUCTIVE') {
    return (
      <TextBodyMedium bold color={theme.colors.functional.B96400}>
        Feedback
      </TextBodyMedium>
    );
  }
  return null;
};
